import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/HomeView.vue'
import Services from '../views/ServicesView.vue'
import Solutions from '../views/SolutionsView.vue'
import About from '../views/AboutView.vue'
import Contact from '../views/ContactView.vue'
import BusinessLicense from '../views/BusinessLicenseView.vue'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/services', name: 'Services', component: Services },
  { path: '/solutions', name: 'Solutions', component: Solutions },
  { path: '/about', name: 'About', component: About },
  { path: '/contact', name: 'Contact', component: Contact },
  {
    path: '/businessLicense',
    name: 'BusinessLicense',
    component: BusinessLicense
  }
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
